var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapControlsToggleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m12 19.175 2.125-2.125 1.425 1.4L12 22l-3.55-3.55 1.425-1.4zM4.825 12l2.125 2.125-1.4 1.425L2 12l3.55-3.55 1.4 1.425zm14.35 0L17.05 9.875l1.4-1.425L22 12l-3.55 3.55-1.4-1.425zM12 4.825 9.875 6.95 8.45 5.55 12 2l3.55 3.55-1.425 1.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapControlsToggleIcon);
export default __webpack_public_path__ + "static/media/map-controls-toggle-icon.0b971fcc291513f39baee92d6a7ebad2.svg";
export { ForwardRef as ReactComponent };